module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-60x60-4f2d90b8a7ed9d981cbd2ba77de4afd9.png";